/*--------------------------------------------------------------
# Custom scripts for FAQs block
--------------------------------------------------------------*/

// const accordionItems = document.querySelectorAll('.faq-item')
// const acc = document.querySelector('.faqs-block')

// accordionItems.forEach((el)=>{
//     el.addEventListener('shown.bs.collapse',(e)=>{
//         var scrollOffset = acc.scrollTop + el.parentNode.offsetTop
//         var offsetHeader = scrollOffset + 50;

//         window.scrollTo({
//             top: offsetHeader,
//             behavior: 'smooth'
//         });
//     })
// })

let accordionItemsToBeFocused = document.querySelectorAll(".faq-collapse");

accordionItemsToBeFocused.forEach((el)=>{
    el.addEventListener('shown.bs.collapse',(e)=>{
        window.location.href = '#' + el.id
    })
})